import React, { useEffect, useState, useRef } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Buildings, UploadSimple, Trash } from "@phosphor-icons/react";

const FIELDS = [
  ["nome", "Nome da Empresa", "text", "Cris Lingerie Ltda"],
  ["nome_fantasia", "Nome Fantasia", "text", "Cris Lingerie"],
  ["whatsapp_oficial", "WhatsApp Oficial", "text", "(11) 90000-0000"],
  ["email", "E-mail", "email", "contato@suaempresa.com"],
  ["site", "Site", "text", "https://suaempresa.com"],
];

export default function AdminCompany() {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);
  const fileRef = useRef(null);

  const load = async () => {
    try { setCfg((await api.get("/integrations/company")).data); }
    catch { toast.error("Erro ao carregar"); }
  };
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/integrations/company"); setCfg(data); }
      catch { toast.error("Erro ao carregar"); }
    })();
  }, []);

  const set = (k, v) => setCfg((p) => ({ ...p, [k]: v }));

  const onLogo = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (!f.type.startsWith("image/")) return toast.error("Selecione uma imagem");
    if (f.size > 2 * 1024 * 1024) return toast.error("Logo muito grande (max 2MB)");
    const reader = new FileReader();
    reader.onload = () => set("logo", reader.result);
    reader.readAsDataURL(f);
  };

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/integrations/company", {
        nome: cfg.nome, nome_fantasia: cfg.nome_fantasia, logo: cfg.logo,
        whatsapp_oficial: cfg.whatsapp_oficial, email: cfg.email, site: cfg.site,
        mensagem_padrao: cfg.mensagem_padrao,
      });
      toast.success("Dados da empresa salvos");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Erro ao salvar"); }
    finally { setSaving(false); }
  };

  if (!cfg) return <div className="text-sm tracking-widest uppercase text-[#5C5A57]" data-testid="company-loading">Carregando...</div>;

  return (
    <div data-testid="admin-company-page" className="max-w-3xl">
      <div className="topbar">
        <div>
          <div className="text-[10px] tracking-[0.2em] uppercase text-[#5C5A57]">Configuracoes</div>
          <h1 className="font-display text-4xl font-bold tracking-tight mt-1">Empresa</h1>
        </div>
        <Buildings size={42} weight="duotone" />
      </div>

      <section className="border border-[#EBE5DF] bg-white p-6 mb-6">
        <h2 className="section-title mb-1">Identidade</h2>
        <div className="text-xs text-[#5C5A57] mb-5">Estes dados sao usados em todas as mensagens automaticas. O nome aparece como <strong>{"{empresa_nome}"}</strong> nas cobrancas.</div>

        {/* Logo */}
        <div className="flex items-center gap-5 mb-6">
          <div className="w-24 h-24 border border-[#EBE5DF] bg-[#FAF7F3] grid place-items-center overflow-hidden shrink-0" data-testid="company-logo-preview">
            {cfg.logo ? <img src={cfg.logo} alt="logo" className="w-full h-full object-contain" /> : <Buildings size={32} weight="duotone" className="text-[#C9C2BA]" />}
          </div>
          <div className="flex flex-col gap-2">
            <input ref={fileRef} type="file" accept="image/*" onChange={onLogo} className="hidden" data-testid="company-logo-input" />
            <button onClick={() => fileRef.current?.click()} className="brand inline-flex items-center gap-2" data-testid="company-logo-btn"><UploadSimple size={16} /> Enviar logo</button>
            {cfg.logo && <button onClick={() => set("logo", "")} className="text-[10px] tracking-widest uppercase text-[#8B5E5E] hover:underline inline-flex items-center gap-1" data-testid="company-logo-remove"><Trash size={12} /> Remover logo</button>}
            <span className="text-[11px] text-[#9A938C]">PNG/JPG, ate 2MB.</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {FIELDS.map(([k, label, type, ph]) => (
            <div key={k}>
              <label className="block text-[10px] tracking-widest uppercase text-[#5C5A57] mb-1">{label}</label>
              <input type={type} className="input-underline" placeholder={ph} value={cfg[k] || ""} onChange={(e) => set(k, e.target.value)} data-testid={`company-${k}-input`} />
            </div>
          ))}
        </div>

        <div className="mt-4">
          <label className="block text-[10px] tracking-widest uppercase text-[#5C5A57] mb-1">Mensagem padrao de atendimento</label>
          <textarea rows={3} className="w-full p-3 border border-[#EBE5DF] text-sm" placeholder="Ola! Aqui e o atendimento oficial da {empresa_nome}. Como posso ajudar?" value={cfg.mensagem_padrao || ""} onChange={(e) => set("mensagem_padrao", e.target.value)} data-testid="company-mensagem-input" />
          <div className="text-[11px] text-[#9A938C] mt-1">Placeholders: {"{empresa_nome}"} · {"{revendedora_nome}"} · {"{cliente_nome}"}</div>
        </div>

        <button onClick={save} disabled={saving} className="brand mt-6" data-testid="company-save-btn">{saving ? "Salvando..." : "Salvar dados da empresa"}</button>
      </section>
    </div>
  );
}
